import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import { JobView } from '../';

class OpportunityView extends React.Component {
  componentDidMount() {
    if(this.props.id) {
      this.props.fetchJob(this.props.id);
    }
  }
  componentWillUpdate(nextProps) {
    if(this.props.id != nextProps.id) {
      this.props.fetchJob(nextProps.id);
    }
  }
  render() {
    const job_container = this.props.downloaded_jobs.find(({job}) => job._id == this.props.previewing_job);
    return <JobView {...(job_container || {})} />;
  }
}

export default connect(({jobs}) => ({...jobs}), Actions)(OpportunityView);



// WEBPACK FOOTER //
// ./src/browser/components/opportunities/opportunity-view.js